//author: devin
import { S25Util } from "../../util/s25-util";
import { S25FavoriteComponent } from "./s25.favorite.component";
import { jSith } from "../../util/jquery-replacement";

export class FavoriteApi {
    public static Instances: S25FavoriteComponent[] = [];

    static refreshInstances(data?: any) {
        jSith.forEach(FavoriteApi.Instances, (_: any, instance: S25FavoriteComponent) => {
            //if same id and type, update fav and view
            if (
                instance.looseItem &&
                instance.isLoggedIn &&
                S25Util.parseInt(instance.looseItem.itemId) === S25Util.parseInt(data.itemId) &&
                S25Util.parseInt(instance.looseItem.itemTypeId) === S25Util.parseInt(data.itemTypeId)
            ) {
                instance.refresh(data.isFav);
            }
        });
    }
}
